import { Conversation } from 'utils/types';

export function parseToadMessageObject(message: string) {
  const match = message.match(/^\{.*?\}/);

  if (match) {
    const jsonString = match[0];
    try {
      const parsedObject: Conversation = JSON.parse(jsonString);
      return parsedObject;
    } catch (error) {
      return {} as Conversation;
    }
  } else {
    return {} as Conversation;
  }
}

export function parseToadMessageText(message: string) {
  return message.replace(/^\{.*?\}/s, '').replace(/^\s+/, '');
}
